<template>
  <div :id="!!id.length ? id : null" class="location-map push-v--desktop--large push-v--tablet--large push-v--mobile--large col-12">
    <div class="col-12 np--all location-map__title--wrapper">
      <h2
          ref="title"
          class="location-map__title h5 text-center push-v--desktop--small push-v--tablet--x-small push-v--mobile--x-small"
      >
        {{ title }}
      </h2>
    </div>
    <div ref="images" class="container">
      <div class="row justify-content-center align-items-center">
        <div class="location-map__details">
          <div v-if="googleMap.latitude && googleMap.longitude" class="location-map__google-map-wrapper">
            <google-map v-bind="googleMap" />
          </div>
          <aside class="location-map__overlay">
            <article class="location-map__overlay--directions">
              <span class="location-map__overlay--intro">{{ intro }}</span>
              <span class="location-map__overlay--location">{{ location }}</span>  
            </article>
            <a
                class="location-map__overlay__cta btn--small btn--light-green"
                aria-label="see-the-area"
                :href="ctaLink"
            >
              {{ ctaText }}
            </a>
          </aside>
          <div class="location-map__images">
            <div v-for="(image, index) in images" :key="index" :class="`location-map__images--${index+1}`">
              <KenticoResponsiveImage :alt="image.description" :src="image.url" class="location-map__image" :sizes="imageSizes" />
            </div>
          </div>

          <article class="location-map__overlay--address">
            <location-icon class="location-map__overlay--icon" />
            {{ locationDisplayName }} - {{ address }} - <a target="blank" :href="googleMap.linkToGoogleMaps" class="location-map__overlay--google-map-cta">{{ googleMap.linkToGoogleMapsText }}<arrow-icon class="location-map__overlay--arrow-icon" /></a>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleMap from '~/components/components/GoogleMap.vue';
// import GoogleMapsIcon from '~/assets/icons/google-maps.svg?inline';
import LocationIcon from '~/assets/icons/map-icon-black.svg?inline';
import ArrowIcon from '~/assets/icons/arrow-top-right-orange.svg?inline';
import getStatic from '~/utils/get-static';
import { BREAKPOINTS, BREAKPOINT_LG } from '~/utils/constants';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { gsap, CSSPlugin } from 'gsap';

export default {
  components: {
    GoogleMap,
    LocationIcon,
    ArrowIcon,
  },
  props: {
    id: { type: String, default: 'location-map' },
    title: { type: String, default: 'location' },
    intro: { type: String, default: '' },
    locationDisplayName: { type: String, default: 'The Collective' },
    location: { type: String, default: '' },
    ctaLink: { type: String, default: '' },
    ctaText: { type: String, default: 'See the area' },
    directions: { type: String, default: 'Situated on the banks of the canal in Willesden Junction, Old Oak is perfectly positioned to access London, with both tube and rail connections close by.', required: true },
    address: {
      type: String,
      default:
        '<p></p>',
    },
    images: {
      type: Array,
      required: true,
      default() {
        return [
          {
            url: getStatic('/images/content/what-we-do/people-cycling.png'),
            description: 'group of people cycling',
          },
        ];
      },
    },
    googleMap: {
      type: Object,
      default() {
        return {
          latitude: 51.5322,
          longitude: 0.2449,
          linkToGoogleMaps: '',
          linkToGoogleMapsText: 'Open in Google Maps',
        };
      },
    },
  },
  data() {
    return {
      center: { latitude: this.googleMap.latitude, longitude: this.googleMap.longitude },
      markers: [
        {
          position: { latitude: this.googleMap.latitude, longitude: this.googleMap.longitude },
        },
      ],
      imageSizes: {
        default: [900, 750],
        sizes: [
          { breakpoint: BREAKPOINTS[BREAKPOINT_LG], width: 1200, height: 1000 },
        ],
      },

    };
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(CSSPlugin);
    const { title, images } = this.$refs;

    gsap.to(images, {
      y: -230,
      duration: 3,
      ease: 'none',
      scrollTrigger: {
        trigger: images,
        scrub: true,
      },
    });

    gsap.to(title, {
      css: { scale: 1.25 },
      duration: 3,
      ease: 'none',
      scrollTrigger: {
        trigger: title,
        scrub: true,
      },
    });
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_google-map.scss';
@import '~/assets/scss/atomic/modules/_location-map.scss';
</style>
